<div class="dialog-container">
  <div class="header-section mb-3">
    @if (!new) {
    <p class="text-base font-semibold" style="margin: 0px">Attach {{ data?.itemToSetup?.sub_type ? data?.itemToSetup?.sub_type : data?.sub_type }}</p>
    } @if (new) {
    <p class="text-base font-semibold" style="margin: 0px">Add New Attachment</p>
    }

    <button type="button" class="close add-close-button" data-dismiss="modal" (click)="closedialog()">
      <span style="font-size: 24px; font-weight: 600; color: #707070" class="material-icons icons-close-mobile">close</span>
    </button>
  </div>
  <div style="height: 1px; border-bottom: 1px solid #d3dce8; margin: 0 -18px 12px -18px"></div>
  @if (!moveToBack ||(openInboxFiles == false && openMobileDeliveryLink == false)) {
  <div>
    <div class="rounded-2xl border border-[#DCDCDC] hover:border-[#25508E] border-2 cursor-pointer">
      <div
        (drop)="dragged($event)"
        (dragstart)="onDragStart($event)"
        (drag)="onDrag($event)"
        (dragover)="onDrag($event)"
        (dragend)="onDragEnd($event)"
        (dragleave)="myFunction($event)"
        (click)="fileInput.click()"
        class="h-15 m-2 bg-[#EBF0FA] border-dashed rounded-sm border text-center"
      >
        <img src="assets/images/upload-image-icon-form.svg" class="bg-[#FFFFFF] rounded-full mt-[6px] mb-[6px]" />
        <p class="m-auto leading-9 text-sm font-normal text-[#515765]">
          <span class="font-bold text-[#25508e]">Drag and Drop</span> or <span class="font-bold text-[#25508e]">Browse Files</span> from your current
          device
        </p>
        <input hidden type="file" #fileInput multiple (change)="uploadFile($event.target.files)" />
      </div>
    </div>
    @if (!moveToBack ||(files.length == 0 && openInboxFiles == false && openMobileDeliveryLink == false)) {
    <div
      class="rounded-2xl border border-[#DCDCDC] mt-2 hover:border-[#25508E] border-2 cursor-pointer"
      (click)="moveToBack = true; openMobileDeliveryLink = true; openInboxFiles = false"
    >
      <div class="h-15 my-6 mx-2">
        <div class="flex justify-between">
          <div class="flex">
            <img src="assets/images/k-inbox.svg" style="margin: 0px 24px 0 14px !important" />
            <div class="">
              <p class="leading-5 text-sm m-0 font-semibold text-[#18191C]" style="margin-bottom: 2px !important">Kinnect Mobile Upload Link</p>
              <p class="leading-5 text-xs m-0 font-normal text-[#515765]" style="margin-top: 2px !important">
                We’ll text you a secure link to the Kinnect mobile delivery portal.
              </p>
            </div>
          </div>
          <div class="flex">
            <mat-icon style="margin-top: 12px">arrow_right_alt</mat-icon>
          </div>
        </div>
      </div>
    </div>
    <div
      class="rounded-2xl border border-[#DCDCDC] mt-2 hover:border-[#25508E] border-2 cursor-pointer"
      (click)="openMobileDeliveryFile = false; moveToBack = true; openInboxFiles = true; openMobileDeliveryLink = false"
    >
      <div class="h-15 my-6 mx-2">
        <div class="flex justify-between">
          <div class="flex">
            <img src="assets/images/inbox-file.svg" class="mr-4" />
            <div class="">
              <p class="leading-5 text-sm m-0 font-semibold text-[#18191C]" style="margin-bottom: 2px !important">Select a file from My Inbox</p>
              <p class="leading-5 text-xs m-0 font-normal text-[#515765]" style="margin-top: 2px !important">
                Select items from your Kinnect inbox to add as attachments.
              </p>
            </div>
          </div>
          <div class="flex">
            <mat-icon style="margin-top: 12px">arrow_right_alt</mat-icon>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
  } @if (moveToBack&&openInboxFiles) {
  <div class="main-wrapper" style="height: 320px; max-height: 320px; overflow: auto">
    <inbox-attachment-list [inboxFiles]="inboxFiles" [enable_task]="enable_task"> </inbox-attachment-list>
  </div>
  } @if (moveToBack&&openMobileDeliveryLink && !openMobileDeliveryFile) {
  <div class="main-wrapper" style="height: 440px; max-height: 480px; overflow: auto">
    <discovery-link [hideDivider]="'true'"> </discovery-link>
  </div>
  } @if (moveToBack && openMobileDeliveryFile) {
  <div class="main-wrapper" style="height: 440px; max-height: 480px; overflow: auto">
    <mobile-delivery-list-file></mobile-delivery-list-file>
  </div>
  } @if (moveToBack&&files.length) {
  <div class="main-wrapper mt-4">
    <div class="rounded-xl border border-[#53565B22] flex fl-col width-100per" style="height: 320px; max-height: 320px; overflow: auto">
      <!-- COMMON HEADER -->
      <p class="text-base font-semibold leading-6 py-3 pl-3 w-100 border-b border-[#53565B22]">
        Attachments • {{ files.length }} Item{{ files.length > 1 ? 's' : '' }}
      </p>
      <div style="width: 100%">
        <div class="flex justify-between border-solid border-[#53565B22]" style="border-width: 1px">
          <p class="m-0 leading-[34px] text-[#ABA5A3] text-sm font-semibold pl-3">Name</p>
          <div class="flex">
            <p class="m-0 leading-[34px] text-[#ABA5A3] text-sm font-semibold pr-12">Size</p>
            <p class="m-0 leading-[34px] text-[#ABA5A3] text-sm font-semibold pr-6">Status</p>
          </div>
        </div>
        <div class="overflow-auto mt-3">
          @for (file of files; track file; let i = $index) {
          <div class="flex justify-between border-solid rounded border-[#53565B38] mb-3 h-8 bg-white px-3">
            <p class="h-3 m-0" style="line-height: 28px" [matTooltip]="file.name">
              @if (file.status == 'fail') {
              <img src="assets/images/fail-icon.svg" />
              } @if (file.status != 'fail') {
              <img src="assets/images/file-icon.svg" />
              }
              {{ file.name | truncateStrPipe : 20 }}
            </p>
            <div class="flex">
              <p class="h-3 px-8 m-0" style="line-height: 28px">{{ file.size | sizeConvertor }}</p>
              @if (file.status == 'running') {
              <button class="bg-transparent" style="margin-right: 40px; height: 28px">
                <mat-spinner [diameter]="20"></mat-spinner>
              </button>
              } @if (file.status == 'fail') {
              <img
                src="assets/images/info-error-messag.svg"
                style="height: 20px; margin-top: 4px; margin-left: 12px; margin-right: 36px"
                [matTooltip]="file.error_message"
              />
              } @if (file.status == 'Done') {
              <div style="display: flex; height: 28px">
                <button class="bg-transparent" style="margin-left: 6px; height: 28px">
                  <img src="assets/images/completed-check.svg" />
                </button>
                <button
                  style="padding: 0px; width: 30px; height: 28px"
                  mat-icon-button
                  aria-label="three dot icon"
                  [matMenuTriggerFor]="menu"
                  (click)="$event.stopPropagation()"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
              </div>
              }
              <mat-menu #menu="matMenu">
                <button mat-menu-item class="popup-menu-item" (click)="renameFile(file, i)">
                  <p class="text-sm font-semibold text-[#18191C]">
                    <span
                      style="color: #25508e !important; margin-right: 10px !important; position: relative; top: 2px; font-size: 15px !important"
                      class="material-icons material-icons-round menuitem-icon"
                      >edit</span
                    >Rename
                  </p>
                </button>
                <button mat-menu-item class="popup-menu-item" (click)="deleteFile(file, i)">
                  <p class="text-sm font-semibold text-[#18191C]">
                    <span
                      style="color: #25508e !important; margin-right: 10px !important; position: relative; top: 2px; font-size: 15px !important"
                      class="material-icons material-icons-round menuitem-icon"
                      >delete</span
                    >Delete
                  </p>
                </button>
              </mat-menu>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
  }
  <div class="action flex justify-between" style="text-align: start; border-top: 1px solid #d3dce8; margin: 12px -18px 0px -18px">
    <div class="w-24">
      @if (moveToBack && (files.length || openInboxFiles == true || openMobileDeliveryLink == true)) {
      <button
        (click)="files = []; moveToBack = false; openInboxFiles = false; openMobileDeliveryLink = false; openMobileDeliveryFile = false"
        mat-raised-button
        type="submit"
        style="font-size: 12px !important; font-weight: 600; box-shadow: none; margin: 12px 0px 0px 18px"
        class="h-8 rounded-lg text-[#18191C] w-20 text-xs"
      >
        <span class="material-icons" style="position: relative; right: 4px; margin-right: 6px"> arrow_back </span>
        Back
      </button>
      }
    </div>
    <div>
      @if (showToggle) {
      <form [formGroup]="myForm" class="text-center" style="width: 100%">
        <mat-slide-toggle
          formControlName="name"
          style="margin: 18px 18px 0px 18px"
          class="font-normal text-[#515765] text-sm margin-zero"
          (change)="onChange()"
        >
          Mark attachments as complete
        </mat-slide-toggle>
      </form>
      }
    </div>
    <div style="width: 120px">
      @if (moveToBack && (openInboxFiles == true || openMobileDeliveryLink == true)) {
      <button
        mat-raised-button
        type="submit"
        style="font-size: 12px !important; font-weight: 700; margin: 12px 18px 0px 18px"
        class="h-8 bg-[#25508E] rounded-lg text-[#ffffff] w-20 text-xs"
        (click)="savedialog()"
      >
        {{ openMobileDeliveryLink ? 'Continue' : openInboxFiles ? 'Save' : 'Close' }}
      </button>
      }
    </div>
  </div>
</div>
